
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Tempotravelleronrentinpune() {



    const cardData =
    {
        keyword: 'Tempo Traveller on Rent in Pune',
        heading: 'S9 Travels: Tempo Traveller on Rent in Pune',
        headingDescription: 'S9 Travels offers Tempo Traveller on Rent in Pune, providing a spacious, comfortable, and reliable travel experience for group trips, family outings, corporate travel, and more. Our well-maintained Tempo Travellers, available in various seating capacities, come with modern amenities and professional drivers to ensure a smooth and hassle-free journey. Enjoy affordable pricing, on-time service, and 24/7 availability for your travel needs. Book your Tempo Traveller on Rent in Pune with S9 Travels for a convenient and enjoyable ride!',


        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada was built in 1732 by the Peshwas of the Maratha Empire. Once the seat of the Peshwa rulers, this grand palace is known for its magnificent architecture, massive gateways, and intriguing legends. The evening light and sound show offers a captivating retelling of its history, making it a must-visit for history lovers."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, this stunning palace holds great historical significance. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters during the Indian independence movement. The palace is surrounded by lush gardens and houses a museum displaying artifacts related to Gandhi's life and legacy."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. This fort, which was the site of the historic Battle of Sinhagad in 1670, is a favorite among trekking enthusiasts. Visitors can explore the ruins, pay homage to the brave warrior Tanaji Malusare, and enjoy local delicacies like pithla bhakri at nearby food stalls."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene retreat for spiritual seekers. It offers a variety of meditation programs, wellness sessions, and yoga classes in a peaceful environment. The ashram attracts visitors from across the globe looking to rejuvenate their mind and body through mindfulness and meditation."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, Pataleshwar Cave Temple dates back to the 8th century. Carved out of a single basalt rock, this temple features beautiful stone pillars and a sanctum with a Shiva Lingam. The tranquil atmosphere makes it an ideal spot for those seeking a blend of history, spirituality, and ancient architecture."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This unique museum houses an extensive collection of over 20,000 artifacts, including sculptures, paintings, weapons, musical instruments, and everyday household items from different periods of Indian history. It provides a fascinating insight into the artistic heritage of Maharashtra and India as a whole."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "A scenic getaway just a short drive from Pune, Khadakwasla Dam is a perfect spot for nature lovers and picnickers. The dam, which supplies water to Pune, offers stunning views of the reservoir and nearby hills. The cool breeze and peaceful surroundings make it an excellent location for a leisurely evening outing."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known for its vibrant and youthful energy, Fergusson College Road is a popular hangout spot among students and young travelers. It is lined with cafes, bookstores, street vendors, and shopping outlets. Whether you're looking for trendy fashion, delicious street food, or a lively atmosphere, this street has something for everyone."
    },
    {
      "title": "Lal Mahal",
      "description": "A historically significant landmark, Lal Mahal was originally built in the 1630s by Shahaji Bhosale for his son, Chhatrapati Shivaji Maharaj. Though the original structure was destroyed, the reconstructed Lal Mahal offers a glimpse into the childhood of Shivaji Maharaj and features paintings and artifacts related to his life."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully designed landscape park is inspired by the Korakuen Garden in Okayama, Japan. It features manicured lawns, flowing streams, koi ponds, and traditional Japanese-style architecture. It's a perfect place for a peaceful stroll or a relaxing family outing."
    }
],

"services": [
  {
    "name": "Tempo Traveller on Rent in Pune",
    "description": "Rent a spacious and comfortable Tempo Traveller in Pune with S9 Travels. Perfect for group trips, family outings, and more, our Tempo Travellers are ideal for both short and long-distance journeys. Enjoy a reliable and comfortable travel experience with professional chauffeurs ensuring a smooth ride."
  },
  {
    "name": "Rent Tempo Traveller for Group Travel in Pune",
    "description": "Planning a group trip in Pune? Rent a Tempo Traveller with S9 Travels for a comfortable and spacious ride. Whether it's a family outing, a corporate event, or a friends' gathering, our Tempo Travellers are the perfect choice for group travel, offering ample space and a smooth travel experience."
  },
  {
    "name": "Affordable Tempo Traveller Rental in Pune",
    "description": "Looking for an affordable Tempo Traveller rental in Pune? S9 Travels offers budget-friendly rates without compromising on comfort or service quality. Whether you're booking for a short trip or an extended tour, our Tempo Travellers provide great value for money while ensuring a comfortable ride."
  },
  {
    "name": "Book Tempo Traveller for Pune Tours",
    "description": "Explore the best of Pune with a Tempo Traveller rental from S9 Travels. Our spacious vehicles are perfect for sightseeing tours, ensuring you visit all the top attractions in comfort and style. Enjoy a hassle-free tour experience while our experienced drivers guide you through the city's landmarks."
  },
  {
    "name": "Group Travel in Pune by Tempo Traveller",
    "description": "S9 Travels offers the perfect solution for group travel in Pune with our Tempo Traveller rental service. Whether you're traveling with family, friends, or colleagues, our vehicles provide plenty of room and comfort, making it the ideal choice for group outings, city tours, or corporate events."
  },
  {
    "name": "Tempo Traveller Hire for Weddings or Events in Pune",
    "description": "Make your special occasion even more memorable with a Tempo Traveller hire for weddings or events in Pune. Our luxury Tempo Travellers are perfect for transporting guests in style, comfort, and safety. Whether it's for a wedding, anniversary, or any other event, our vehicles ensure a smooth and enjoyable ride for all your guests."
  },
  {
    "name": "Luxury Tempo Traveller Hire in Pune",
    "description": "Travel in luxury with a Tempo Traveller hire from S9 Travels. Our luxury vehicles are equipped with premium amenities, ensuring a top-notch travel experience for you and your group. Whether it's a wedding, corporate event, or leisure trip, our luxury Tempo Travellers provide comfort, style, and sophistication."
  },
  {
    "name": "Tempo Traveller for Outstation Trips from Pune",
    "description": "Going on an outstation trip from Pune? Rent a Tempo Traveller with S9 Travels for a comfortable and spacious ride to your destination. Perfect for family vacations, group getaways, or corporate travel, our Tempo Travellers offer a smooth and relaxing journey for both short and long-distance trips."
  },
  {
    "name": "Comfortable Group Travel with Tempo Traveller in Pune",
    "description": "Enjoy comfortable group travel in Pune with a Tempo Traveller from S9 Travels. Our well-maintained vehicles are perfect for any group travel, ensuring plenty of space, comfortable seating, and a smooth ride. Whether you're touring the city or heading out for an event, our Tempo Travellers provide a hassle-free experience."
  }
],

"tableData": [
  ["Tempo Traveller on Rent in Pune", "Rent Tempo Traveller for Group Travel in Pune"],
  ["Affordable Tempo Traveller Rental in Pune", "Book Tempo Traveller for Pune Tours"],
  ["Group Travel in Pune by Tempo Traveller", "Tempo Traveller Hire for Weddings or Events in Pune"],
  ["Luxury Tempo Traveller Hire in Pune", "Tempo Traveller for Outstation Trips from Pune"],
  ["Comfortable Group Travel with Tempo Traveller in Pune", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Ride",
    "WhyChoosedescription": "S9 Travels offers Tempo Traveller on rent in Pune, providing a comfortable and spacious ride for group travel. With seating options ranging from 9 to 17 seats, it ensures a smooth journey for family trips, corporate events, or sightseeing tours."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of timely travel. Our Tempo Traveller rental service in Pune ensures punctual pick-ups and drop-offs, so you can rely on us to reach your destination on time, whether for business or leisure."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions in Pune. They prioritize your safety, comfort, and convenience, ensuring a pleasant and efficient journey in the Tempo Traveller."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and affordable rates for Tempo Traveller rentals in Pune. We provide a transparent pricing structure with no hidden charges, allowing you to plan your travel budget with ease."
  },
  {
    "WhyChooseheading": "Safety and Comfort During Your Journey",
    "WhyChoosedescription": "Your safety is our priority. All our Tempo Traveller vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your group."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Tempo Traveller rental in Pune. Whether you need an early morning departure or a late-night return, we are here to provide reliable service that fits your schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to make your journey in the Tempo Traveller even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Tempo Traveller rental in Pune with S9 Travels is easy and hassle-free. You can book online through our website or mobile app, or contact our customer service team for personalized assistance to make the booking process quick and convenient."
  }
]














    }

    const faqData = [
        [
          {
            question: 'How can I rent a Tempo Traveller in Pune?',
            answer: 'Renting a Tempo Traveller in Pune is easy! You can book your rental through our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a comfortable and hassle-free rental experience.',
          },
          {
            question: 'What types of Tempo Traveller vehicles are available for rent in Pune?',
            answer: 'We offer a variety of Tempo Traveller vehicles for rent in Pune, including 12-seater, 15-seater, and 20-seater options. Choose the one that best fits your group size and travel needs.',
          },
          {
            question: 'How long can I rent a Tempo Traveller in Pune?',
            answer: 'You can rent a Tempo Traveller in Pune for as long as you need! Whether it’s a few hours, a day, or longer, we provide flexible rental options to suit your schedule and requirements.',
          },
          {
            question: 'Do you provide drivers with the Tempo Traveller rental in Pune?',
            answer: 'Yes, we provide experienced and professional drivers with all Tempo Traveller rentals in Pune. Our drivers are familiar with the best routes and will ensure your comfort and safety throughout the journey.',
          },
          {
            question: 'How much does it cost to rent a Tempo Traveller in Pune?',
            answer: 'The rental cost for a Tempo Traveller depends on factors like the number of seats, the duration of your rental, and any additional services. Contact us for a customized quote based on your specific requirements.',
          },
          {
            question: 'Is there a security deposit required to rent a Tempo Traveller in Pune?',
            answer: 'Yes, a refundable security deposit is required when renting a Tempo Traveller. The deposit amount varies depending on the vehicle and rental duration.',
          },
          {
            question: 'Can I pick up the Tempo Traveller from a specific location in Pune?',
            answer: 'Yes, we offer flexible pick-up options. You can pick up your rented Tempo Traveller from a location of your choice in Pune, including your home, office, or any other convenient spot.',
          },
          {
            question: 'Can I extend my Tempo Traveller rental if I need more time?',
            answer: 'Yes, you can extend your Tempo Traveller rental in Pune based on availability. Simply contact our customer service team, and they will assist you with the extension.',
          },
          {
            question: 'Do you offer delivery and pick-up services for Tempo Traveller rentals in Pune?',
            answer: 'Yes, we offer delivery and pick-up services for your Tempo Traveller rental. We will ensure that the vehicle is delivered to your location and picked up at the end of your rental period.',
          },
          {
            question: 'Why should I choose S9 Travels for renting a Tempo Traveller in Pune?',
            answer: 'S9 Travels offers reliable, affordable, and comfortable Tempo Traveller rentals in Pune. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a smooth and enjoyable rental experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I rented a Tempo Traveller from S9 Travels for a family trip in Pune, and it was a fantastic experience. The vehicle was clean, comfortable, and spacious. The driver was professional and knew the best routes in the city. The entire booking process was smooth, and I highly recommend S9 Travels for anyone looking to rent a Tempo Traveller in Pune.”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Pune with a Tempo Traveller from S9 Travels was excellent. The vehicle was perfect for our large group, and the driver was friendly, experienced, and very helpful. We had a smooth and enjoyable ride. I will definitely consider S9 Travels for future rentals in Pune.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Tempo Traveller on Rent in Pune",
        "description": "Book affordable and luxury Tempo Traveller rental services in Pune for group travel, weddings, events, tours, and outstation trips. S9 Travels offers comfortable and reliable Tempo Traveller rentals for all your transportation needs in Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      


    return (
        <div>
         <Helmet>
        <title>Tempo Traveller on Rent in Pune | S9 Travels </title>
        <meta 
          name="description" 
          content="Book Tempo Traveller on rent in Pune for group travel, weddings, events, tours, and outstation trips. Affordable, luxury Tempo Traveller rental services for comfortable and reliable transportation in Pune with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/73.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Tempotravelleronrentinpune;